import React from 'react'
import { Button, Form, Grid, Header, Message, Segment } from 'semantic-ui-react'
import MaskedInput from 'react-text-mask'
import { Auth, Logger } from 'aws-amplify';
import { AuthPiece } from 'aws-amplify-react';

const logger = new Logger('RegisterForm');

class RegisterForm extends AuthPiece {
    constructor(props) {
        super(props);

        this.signUp = this.signUp.bind(this);
        this.state = {}
        //console.log('in registerform', this.props);
        console.log('in registerform names passed', this.props.names);
        const subName = this.props.names.newName1 + this.props.names.newName2
        const participantIdentifier = this.props.names.participant
        console.log('name to check', subName);
        console.log('participant to check', participantIdentifier);
    }

    signUp() {
        const { username, password, email, phone_number } = this.inputs;
        console.log('entire form return, ideally  ', this.inputs);
        console.log('props from form return  ', this.props );
        console.log('children from props on form return  ', this.props.children );
        const sanitizedPhoneNumber = phone_number.replace(/[ ()-]/g, '');
        console.log('should be sanitized phone number', sanitizedPhoneNumber);
        const participantIdentifier = this.props.names.participant;
        const participantIdentifier2 = localStorage.getItem("participantId_toUse");
        console.log('should be participant ID', participantIdentifier2);
        const leaderBoardName = 'snowyMonday';
        const subName = this.props.names.newName1 + this.props.names.newName2
        logger.debug('username: ' + username);
        Auth.signUp({
             'username': subName,
             'password': password,
             'attributes': {
                'email': email,
                'phone_number': sanitizedPhoneNumber,
                 'custom:participantId': participantIdentifier2,
                 'custom:leaderBoardName': subName,
            }
        })
            .then(data => this.changeState('confirmSignUp', data))
            .catch(err => this.error(err));
    }

    render() {
        const { authState, leaderboardName } = this.props;
        const subName = this.props.names.newName1 + this.props.names.newName2
        if ('signUp' !== authState) { return null; }

        return (
            <div className='login-form'>
              {/*
                Heads up! The styles below are necessary for the correct render of this example.
                You can do same with CSS, the main idea is that all the elements up to the `Grid`
                below must have a height of 100%.
              */}
              <style>{`
                body > div,
                body > div > div,
                body > div > div > div.login-form {
                  height: 100%;
                }
              `}</style>
              <Grid
                textAlign='center'
                style={{ height: '100%' }}
                verticalAlign='middle'
              >
                <Grid.Column style={{ maxWidth: 450 }}>
                  <Header as='h2' color='teal' textAlign='center'>
                    {' '}
                  </Header>
                  <Form size='large'>
                    <Segment>
                      <Form.Input
                        autoFocus
                        fluid
                        icon='user'
                        iconPosition='left'
                        placeholder={subName}
                        name={subName}
                        onChange={this.handleInputChange}
                      />
                      <Form.Input
                        fluid
                        icon='lock'
                        iconPosition='left'
                        placeholder='Password'
                        type='password'
                        name="password"
                        onChange={this.handleInputChange}
                      />
                      <Form.Input
                        fluid
                        icon='mail'
                        iconPosition='left'
                        placeholder='Email'
                        name="email"
                        onChange={this.handleInputChange}
                      />
                      <Form.Input
                        fluid
                        icon='phone'
                        iconPosition='left'
                        children={
                            <MaskedInput
                              mask={['+', '1',  '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                              placeholder="+1 (123) 456-7890"
                              onChange={this.handleInputChange}
                              name="phone_number"
                            />
                        }
                      />

                      <Button
                            color='teal'
                            fluid
                            size='large'
                            onClick={this.signUp}
                      >Register</Button>
                    </Segment>
                  </Form>
                </Grid.Column>
              </Grid>
            </div>
        )
    }
}

export default RegisterForm



// WEBPACK FOOTER //
// ./src/components/RegisterForm.js